module.exports = __webpack_public_path__ + "static/img/r_014.228d52d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_014.jpg
// module id = 1W26
// module chunks = 1